﻿// Biến cấp Module (Private trong module này)
let reconnectModal = null;
let retryButton = null;
let resumeButton = null;

// --- PUBLIC METHODS (Export ra ngoài) ---

export function blInitReconnectHandler() {
    // 1. Tìm các element
    reconnectModal = document.getElementById("components-reconnect-modal");
    retryButton = document.getElementById("components-reconnect-button");
    resumeButton = document.getElementById("components-resume-button");

    // Nếu không tìm thấy modal (ví dụ trang này không dùng), thì thoát luôn
    if (!reconnectModal) return;

    // 2. Gán sự kiện
    // Blazor sẽ bắn event này vào phần tử modal khi mất kết nối
    reconnectModal.addEventListener("components-reconnect-state-changed", handleReconnectStateChanged);

    if (retryButton) {
        retryButton.addEventListener("click", retry);
    }

    if (resumeButton) {
        resumeButton.addEventListener("click", resume);
    }
}

export function blDisposeReconnectHandler() {
    // Hàm này để dọn dẹp nếu cần (dù thường modal này sống suốt đời app)
    if (reconnectModal) {
        reconnectModal.removeEventListener("components-reconnect-state-changed", handleReconnectStateChanged);
    }
    if (retryButton) retryButton.removeEventListener("click", retry);
    if (resumeButton) resumeButton.removeEventListener("click", resume);
    document.removeEventListener("visibilitychange", retryWhenDocumentBecomesVisible);
}

// --- PRIVATE METHODS (Nội bộ) ---

function handleReconnectStateChanged(event) {
    if (!event || !event.detail) return;

    const state = event.detail.state;

    if (state === "show") {
        reconnectModal.showModal();
    } else if (state === "hide") {
        reconnectModal.close();
    } else if (state === "failed") {
        // Nếu failed, tự động thử lại khi người dùng quay lại tab
        document.addEventListener("visibilitychange", retryWhenDocumentBecomesVisible);
    } else if (state === "rejected") {
        // Rejected nghĩa là server từ chối (có thể do phiên bản cũ), reload trang là tốt nhất
        location.reload();
    }
}

async function retry() {
    document.removeEventListener("visibilitychange", retryWhenDocumentBecomesVisible);

    try {
        // Lưu ý: Dùng window.Blazor để đảm bảo truy cập đúng biến global
        const successful = await window.Blazor.reconnect();

        if (!successful) {
            // Kết nối được server nhưng circuit cũ đã mất -> Thử resume
            const resumeSuccessful = await window.Blazor.resumeCircuit();
            if (!resumeSuccessful) {
                location.reload();
            } else {
                reconnectModal.close();
            }
        }
    } catch (err) {
        // Vẫn lỗi -> Đợi user quay lại tab lần sau thử tiếp
        console.error("Reconnect failed:", err);
        document.addEventListener("visibilitychange", retryWhenDocumentBecomesVisible);
    }
}

async function resume() {
    try {
        const successful = await window.Blazor.resumeCircuit();
        if (!successful) {
            location.reload();
        }
    } catch {
        // Thay đổi class để hiển thị UI báo lỗi resume
        reconnectModal.classList.replace("components-reconnect-paused", "components-reconnect-resume-failed");
    }
}

async function retryWhenDocumentBecomesVisible() {
    if (document.visibilityState === "visible") {
        await retry();
    }
}